import React from 'react';
import PropTypes from 'prop-types';
import { Link } from '@one-thd/sui-atomic-components';
import { CreateAProject } from '@thd-olt-component-react/project-forms';
import { QueryProvider } from '@thd-nucleus/data-sources';
import {
  handleProjectCreationFromNullState,
  triggerProjectsInteractionAnalytics,
} from '../../utils/helpers';

export const getProjectsHeaderActionMap = ({ hasProjects, componentId, hideViewAllSuffix }) => {
  const viewAllPayload = {
    action: 'clickthrough',
    component: 'view all',
    id: componentId,
  };

  const learnMorePayload = {
    action: 'clickthrough',
    component: 'null state learn more',
    id: componentId,
  };

  const CreateNewLinkElement = ({ onClick }) => {
    return (
      // eslint-disable-next-line jsx-a11y/anchor-is-valid
      <Link
        href="#"
        onClick={(eve) => {
          eve.preventDefault();

          triggerProjectsInteractionAnalytics({
            action: 'button-click',
            id: componentId,
            component: 'create new',
          });

          onClick(eve);
        }}
      >
        Create New
      </Link>
    );
  };

  CreateNewLinkElement.propTypes = {
    onClick: PropTypes.func.isRequired,
  };

  CreateNewLinkElement.displayName = 'CreateNewLinkElement';

  return {
    createNew: (
      <QueryProvider cacheKey="projects-header-create-project">
        <CreateAProject
          CustomCreateProjectActionElement={CreateNewLinkElement}
          onCreate={(newProject) => handleProjectCreationFromNullState({ newProject, hasProjects: true, componentId })}
        />
      </QueryProvider>
    ),
    learnMore: (
      <Link
        href="/c/create-a-project"
        onClick={() => triggerProjectsInteractionAnalytics(learnMorePayload)}
      >
        Learn More
      </Link>
    ),
    viewAll: (
      <Link
        href="/projects"
        onClick={() => triggerProjectsInteractionAnalytics(viewAllPayload)}
      >
        {hideViewAllSuffix ? 'View All' : 'View All Projects'}
      </Link>
    )
  };
};